import {
  UPDATE_PAYMENT_STATUS_LOADING,
  UPDATE_PAYMENT_STATUS_SUCCESS,
  UPDATE_PAYMENT_STATUS_FAILED,
} from "../types";

interface PaymentStatusState {
  loading: boolean;
  data: any;
  error: string | null;
}

const initialState: PaymentStatusState = {
  loading: false,
  data: null,
  error: null,
};

const updatePaymentStatusReducer = (
  state = initialState,
  action: any
): PaymentStatusState => {
  switch (action.type) {
    case UPDATE_PAYMENT_STATUS_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case UPDATE_PAYMENT_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case UPDATE_PAYMENT_STATUS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default updatePaymentStatusReducer;
